const colour = {
  background: "#1a1a1a",
  text: "white",
  accent: "#7aa648",
};

export { colour };
